
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Service for rejecting interviews that don't meet publication standards
 */
export class RejectInterviewService {
  /**
   * Reject an interview and optionally provide a reason
   * @param interviewId - The ID of the interview to reject
   * @param reason - Optional reason for rejection (for internal tracking)
   * @returns Promise resolving to true if successful
   */
  static async rejectInterview(interviewId: string, reason?: string): Promise<boolean> {
    console.log('Rejecting interview:', interviewId, reason ? `Reason: ${reason}` : '');
    
    try {
      // Update the interview status to rejected
      const { error } = await supabase
        .from('interviews')
        .update({ 
          publication_status: 'rejected',
          is_in_feeder: false, // Remove from feeder queue if it was there
          updated_at: new Date().toISOString()
        } as any)
        .eq('id', interviewId as any);
        
      if (error) {
        console.error('Error rejecting interview:', error);
        toast.error(`Failed to reject interview: ${error.message}`);
        throw new Error(`Failed to reject interview: ${error.message}`);
      }
      
      console.log('Interview successfully rejected:', interviewId);
      return true;
    } catch (error) {
      console.error('Exception in RejectInterviewService:', error);
      throw error;
    }
  }
}
